export const GET_BILLING_REPORT_STARTED = "GET_BILLING_REPORT_TODAY_STARTED"
export const GET_BILLING_REPORT_SUCCESS = "GET_BILLING_REPORT_SUCCESS"
export const GET_BILLING_REPORT_FAILURE = "GET_BILLING_REPORT_FAILURE"

export const GET_EXACT_REPORT_STARTED = "GET_EXACT_REPORT_STARTED"
export const GET_EXACT_REPORT_SUCCESS = "GET_EXACT_REPORT_SUCCESS"
export const GET_EXACT_REPORT_FAILURE = "GET_EXACT_REPORT_FAILURE"

export const REMOVE_ERROR_MESSAGE = "REMOVE_ERROR_MESSAGE"